// extracted by mini-css-extract-plugin
export default {"page":"Modal_page__ul9J0","middle":"Modal_middle__kJWx6","left":"Modal_left__JqqtP","right":"Modal_right__H3NI8"};